var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"tabActive":4}}),_c('ScrollSmall',{attrs:{"pageSmallTile":_vm.pageSmallTile}}),_c('AboutContent'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }